import { Routes } from '@angular/router';
import { loginGuard } from '@kimbocare/auth';
import { guestGuard } from './core/guard/guest.guard';
import { HasNotSubsGuard, hasSubscriptionMatch, HasSubsGuard } from './core/guard/subscription.guards';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/features.module').then((m) => m.FeaturesModule),
    canActivate: [loginGuard()],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./authentication/authentication.module').then((m) => m.AuthenticationModule),
    canActivate: [guestGuard()],
  },
   {
    path: 'subscriptions',
    loadChildren: () =>
      import('./features/subscriptions/subscriptions.module').then(
        m => m.SubscriptionsModule
      ),
    canActivate: [loginGuard(), HasNotSubsGuard()],
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./features/error/error.module').then((m) => m.ErrorModule),
  },
  {
    path: '**',
    redirectTo: 'error/error404',
    pathMatch: 'full',
  },
];
